// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legends *[stroke="var(--vis-color1)"]:not([style*="fill"]) {
    stroke-dasharray: 5;
}

.legends *[stroke="var(--vis-color2)"]:not([style*="fill"]) {
    marker: url('#circle-marker');
  }
  
.legends *[stroke="var(--vis-color3)"]:not([style*="fill"]) {
    stroke-dasharray: 2;
  }
  
.legends *[stroke="var(--vis-color4)"]:not([style*="fill"]) {
  marker: url('#square-marker');
}

.legends *[stroke="var(--vis-color5)"]:not([style*="fill"]) {
  marker: url('#arrow-marker');
  stroke-dasharray: 2 7;
}`, "",{"version":3,"sources":["webpack://./src/examples/auxiliary/bullet-legend/line-legend/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;EAC/B;;AAEF;IACI,mBAAmB;EACrB;;AAEF;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB","sourcesContent":[".legends *[stroke=\"var(--vis-color1)\"]:not([style*=\"fill\"]) {\n    stroke-dasharray: 5;\n}\n\n.legends *[stroke=\"var(--vis-color2)\"]:not([style*=\"fill\"]) {\n    marker: url('#circle-marker');\n  }\n  \n.legends *[stroke=\"var(--vis-color3)\"]:not([style*=\"fill\"]) {\n    stroke-dasharray: 2;\n  }\n  \n.legends *[stroke=\"var(--vis-color4)\"]:not([style*=\"fill\"]) {\n  marker: url('#square-marker');\n}\n\n.legends *[stroke=\"var(--vis-color5)\"]:not([style*=\"fill\"]) {\n  marker: url('#arrow-marker');\n  stroke-dasharray: 2 7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legends": `legends`
};
export default ___CSS_LOADER_EXPORT___;
